import React, { useEffect } from 'react';

import { SearchParamType, useNavigation } from '@atom/hooks/useNavigation';
import { MapAsset, MapUser, MapWorkOrder } from '@atom/types/map';

import AssetListItem from '../drawerContent/AssetsListItem_v2';
import UserListItem from '../drawerContent/UserListItem_v2';
import WorkOrderListItem from '../drawerContent/WorkOrdersListItem_v2';

interface Props {
  param: string;
  row: MapAsset | MapUser | MapWorkOrder;
}

const componentMap = {
  asset: AssetListItem,
  user: UserListItem,
  workOrder: WorkOrderListItem,
};

const ListItemWrapper = ({ param, row }: Props) => {
  const Component = componentMap[param];

  const ref = React.useRef<HTMLDivElement>(null);
  const [{ hover }, { updateSearchParams }] = useNavigation({
    id: SearchParamType.STRING,
    hover: SearchParamType.STRING,
    view: SearchParamType.STRING,
  });

  const itemHover = newHover => {
    updateSearchParams({ hover: newHover });
  };

  const itemClick = (id, view) => {
    updateSearchParams({ id, view });
  };

  const hoverParams = (id, view) => ({
    onMouseEnter: () => {
      itemHover(id);
    },
    onMouseLeave: () => {
      updateSearchParams({ hover: null });
    },
    onClick: () => {
      itemClick(id, view);
    },
  });

  useEffect(() => {
    if (hover === row.id) {
      if (ref && ref.current) {
        // @ts-ignore
        ref.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  if (!Component) {
    return null;
  }

  const props = { [param]: row };

  return (
    <div {...hoverParams(row.id, param)} ref={ref}>
      <Component {...props} />
    </div>
  );
};

export default ListItemWrapper;
